import { InvitationPage } from 'app/BCKSPage/Invitation'
import MaintenanceModePage from 'app/BCKSPage/MaintenanceMode'
import { isToggleEnabled } from 'configs/toggle-feature'

interface PropsInvitationIndexPage {
  isKSSelectionEnabled: boolean
  isKSSeleksiTertutupEnabled: boolean
}

export const getServerSideProps = async () => {
  const isKSSelectionEnabled = await isToggleEnabled('ks-selection-enabled')
  const isKSSeleksiTertutupEnabled = await isToggleEnabled(
    'ks-selection-seleksi-tertutup-enabled'
  )

  return {
    props: {
      isKSSelectionEnabled,
      isKSSeleksiTertutupEnabled,
    },
  }
}

const InvitationIndexPage = (props: PropsInvitationIndexPage) => {
  if (!props.isKSSelectionEnabled) {
    return <MaintenanceModePage />
  }

  return (
    <InvitationPage
      isKSSeleksiTertutupEnabled={props.isKSSeleksiTertutupEnabled}
    />
  )
}

// eslint-disable-next-line react/display-name
InvitationIndexPage.Layout = ({ children }) => children

export default InvitationIndexPage
